import { render, staticRenderFns } from "./cart-items.vue?vue&type=template&id=6d42ca8b&scoped=true"
import script from "./cart-items.vue?vue&type=script&lang=ts"
export * from "./cart-items.vue?vue&type=script&lang=ts"
import style0 from "./cart-items.vue?vue&type=style&index=0&id=6d42ca8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d42ca8b",
  null
  
)

export default component.exports